export default "/_next/static/images/sofa-58c670207d3c4e36771cdd3af8c02045.png";